import { render, staticRenderFns } from "./ScrollView.vue?vue&type=template&id=580903af&scoped=true"
import script from "./ScrollView.vue?vue&type=script&lang=js"
export * from "./ScrollView.vue?vue&type=script&lang=js"
import style0 from "./ScrollView.vue?vue&type=style&index=0&id=580903af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580903af",
  null
  
)

export default component.exports